export default __webpack_public_path__ + "static/media/MyTasksActiveIcon.2685d0df.svg";